import React from 'react'
import { Button, Tooltip } from '@material-ui/core'

import { ReactComponent as UploadIconSvg } from 'assets/icons/upload.svg'

import { snackbar } from '../snackbars'

interface UploadButtonProps {
  id: string
  accept: string
  label: React.ReactNode
  options?: object
  onChange: (file: File, options?: object) => void
  maxSizeInMB?: number
  withoutStartIcon?: boolean
  disabled?: boolean
}

const UploadButton: React.FC<UploadButtonProps> = ({
  id,
  accept,
  label,
  onChange,
  options,
  maxSizeInMB,
  withoutStartIcon,
  disabled = false,
}) => {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    if (disabled || !e.target.files?.length) return
    const file = e.target.files[0]

    if (maxSizeInMB && file.size > maxSizeInMB * 1024 * 1024) {
      snackbar.show(`El tamaño del archivo debe ser menor a ${maxSizeInMB} MB`)
      return
    }

    const extensions = accept
      .replace(/\s/g, '') // Eliminar espacios
      .split(',') // Dividir por comas
      .map(ext => ext.replace('.', '')) // Eliminar el punto inicial de cada extensión

    const regex = new RegExp(`(${extensions.join('|')})$`, 'i')

    if (!regex.test(file.type)) {
      snackbar.show(`El archivo debe ser en formato ${accept}`)
      return
    }

    onChange(file, options)
  }

  return (
    <label htmlFor={id} style={{ width: '100%', paddingBottom: 0 }}>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id={id}
        type="file"
        onChange={handleChange}
        disabled={disabled}
      />
      <Tooltip title={`Formatos compatibles: ${accept}`} placement="bottom">
        <Button
          variant="contained"
          color="primary"
          style={{
            borderRadius: '5px',
            fontSize: '14px',
            fontWeight: 400,
            fontFamily: 'Montserrat',
            lineHeight: '100%',
            letterSpacing: 0,
            width: '100%',
            minWidth: '110px',
            minHeight: '40px',
            textTransform: 'none',
          }}
          component="span"
          startIcon={withoutStartIcon ? undefined : <UploadIconSvg />}
          disabled={disabled}
        >
          {label}
        </Button>
      </Tooltip>
    </label>
  )
}

UploadButton.defaultProps = {
  options: {},
  maxSizeInMB: undefined,
  withoutStartIcon: false,
  disabled: false,
}

export { UploadButton }
